// extracted by mini-css-extract-plugin
export default {"nav_items":"NavbarItem_nav_items__bbUhf","item":"NavbarItem_item__roj9q"};